import ko from 'knockout'
import { MatchedFieldSummary } from '@core/Areas/Racing/Components/FieldSummary/MatchedFieldSummary'
import type { BettingInformation } from '../../../Model/BettingInformation'
import type ObservableDogStarter from '../../../Model/Observables/ObservableDogStarter'
import type ObservableRaceKey from '../../../Model/Observables/ObservableRaceKey'
import BaseStarterViewModel from './../BaseStarterViewModel'

export interface Params {
  data: ObservableDogStarter
  raceNumber: ObservableRaceKey
  context: { bettingContext: BettingInformation }
  numberOfStartersInRace: ko.Computed<number>
  doubleProvDivAllowed: ko.Observable<boolean>
  quaddieProvDivAllowed: ko.Observable<boolean>
  isRaceClosed: ko.Observable<boolean>
}

export class DogStarterViewModel extends BaseStarterViewModel {
  public MatchedFieldSummary = MatchedFieldSummary

  constructor(params: Params) {
    super(
      params.data,
      params.raceNumber,
      params.context.bettingContext,
      'Dogs',
      params.numberOfStartersInRace,
      params.doubleProvDivAllowed,
      params.quaddieProvDivAllowed,
      params.isRaceClosed
    )

    this.stripes = ko.observableArray<number>([])
    for (let i = 1; i <= params.data.stripeCount(); ++i) {
      this.stripes.push(i)
    }
    this.stripeClass = stripe => 'stripe-' + stripe
  }

  public stripes!: ko.ObservableArray<number>
  public stripeClass!: (arg: number) => string
}
